export const messages = {
    api: {
        error: 'Algo salió mal :('
    }
};

export const contactData = {
    cellphone: '3413742823',
    email: 'ventasweb@ciafarma.com.ar',
    direccion: 'Álvarez Condarco 327 bis'
};
